<script setup>
const props = defineProps({
  button: Object,
  isAndroid: { type: Boolean, default: false},
  akey: { type: String, default: '' }
})

const androidRegistrationLink = ref('')
onMounted(() => {
  if (props.akey) {
    androidRegistrationLink.value = `opensafaris://weathernews.jp/sakura/aicamera/registration_redirect/?akey=${props.akey}`
  } else {
    androidRegistrationLink.value = 'opensafaris://weathernews.jp/sakura/aicamera/registration_redirect/'
  }
})

</script>

<template>
  <NuxtLink v-if="!isAndroid" :to="button.link" :data-active="button.isActive" class="commonButton">
    <p>{{ button.text }}</p>
  </NuxtLink>
  <a v-else :href="androidRegistrationLink" :data-active="button.isActive" class="commonButton">
    <p>{{ button.text }}</p>
  </a>
</template>

<style lang="scss" scoped>
.commonButton {
  display: block;
  width: 100%;
  padding: 16px;
  border-radius: 100vmax;
  border: 1px solid $border;
  background: linear-gradient(0deg, $strong 35.5%, #FF93AE 100%);
  box-shadow: 0 2px 4px 0 rgb(255 14 175 / .3);
  opacity: .3;
  transition: opacity .25s ease-in-out;
  p {
    color: $white;
    font-size: 16px;
    font-weight: 600;
    line-height: 1em;
    text-align: center;
  }
  &[data-active='true'] {
    opacity: 1;
  }
}
</style>
